import { render, staticRenderFns } from "./ekk_detail.vue?vue&type=template&id=57ff6def"
import script from "./ekk_detail.vue?vue&type=script&lang=js"
export * from "./ekk_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports